export default __webpack_public_path__ + "static/trombone-598281724d930b6881581d06ce1561fc.png";